import script from "./ModalConfirmMarkAsRead.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalConfirmMarkAsRead.vue?vue&type=script&lang=ts&setup=true"

import "./ModalConfirmMarkAsRead.vue?vue&type=style&index=0&id=449451c2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449451c2"]])

export default __exports__